
import { ResponseMapperType, NormalizedQuickWebTokenResponse, TokenResponseMapper } from './api/types'
import { createQuickWebToken } from './api/quickWebToken'
import { redirectToWestpac } from './helpers/redirectToWestpac';

export interface QuickVaultCreditCardPaymentButtonParameters {
  quickWebTokenHandlerEndpoint: string;
  formUrl: string;
  communityCode: string;
  customerReferenceNumber: string;
  returnUrl: string;
  cancelUrl: string;
  supplierBusinessCode: string;
  partner: string;
  requestHeaders: HeadersInit | string;
  responseMapper?: TokenResponseMapper;
  mapResponseType?: ResponseMapperType | string;
  onBeforePaymentSubmit?: Function
}

export const quickVaultCreditCardPaymentButton = async ({
  quickWebTokenHandlerEndpoint,
  formUrl,
  communityCode,
  customerReferenceNumber,
  returnUrl,
  cancelUrl,
  supplierBusinessCode,
  partner,
  responseMapper,
  mapResponseType,
  requestHeaders,
  onBeforePaymentSubmit
}: QuickVaultCreditCardPaymentButtonParameters) => {

  const quickWebTokenApi = createQuickWebToken({
    quickWebTokenHandlerEndpoint,
    responseMapper,
    mapResponseType,
    requestHeaders,
    onBeforePaymentSubmit
  });

  const { token } = await quickWebTokenApi.generateToken({
    customerReferenceNumber,
    returnUrl,
    cancelUrl,
    supplierBusinessCode,
    partner
  });

  redirectToWestpac({
    token,
    formUrl,
    communityCode,
    customerReferenceNumber: customerReferenceNumber
  });
};
